import {
  EOrderingProductionStatus,
  ScgExportRejectReason
} from "@saleor/graphql";

export enum ViewEditMode {
  VIEW = "VIEW",
  EDIT = "EDIT",
  ADD = "ADD"
}

export enum ChangeOrderTab {
  agency = "agency",
  orderHeader = "orderHeader",
  materialItem = "materialItem",
  addNewItem = "addNewItem"
}

export enum TypeOfAddProd {
  Successfully = "success",
  UnSuccessfully = "error"
}

export enum TypeConfirm {
  SUBMIT = "submit",
  CANCEL = "cancel",

  REVERT = "revert"
}

export enum TypeSubmit {
  SUBMIT_HEADER = 1,
  SUBMIT_MATERIAL = 2
}

export enum TypeBlock {
  BLOCK_EDIT = "BLOCK_EDIT",
  BLOCK_ADD = "BLOCK_ADD"
}

export const conditionGroupOptions = [
  {
    value: "C1",
    label: "C1 - Container 20'"
  },
  {
    value: "C2",
    label: "C2 - Container 40'"
  },
  {
    value: "C3",
    label: "C3 - Container 40' H"
  }
];

export interface IListMaterial {
  itemStatusEn?: string;
  dateBeforeConfirm?: boolean;
  conditionGroup1?: string;
  itemRemain: string;
  id?: string;
  itemNo: string;
  allowChangeInquiryMethod?: boolean;
  material: string;
  materialDesc: string;
  itemQty: string;
  salesUnit: string;
  plant: string;
  paymentTerm: string;
  poNumber: string;
  itemCategory: string;
  materialGroup1: string;
  saleText1Th: string;
  routeId: string;
  routeName: string;
  requestDate: string;
  untimatedTol: string;
  weightPerUnit: string;
  orderQty: string;
  comfirmQty: string;
  deliveryQty: string;
  deliveryStatus: string;
  saleQtyDivision: string;
  saleQtyFactor: string;
  prdHierachy: string;
  shippingPoint: string;
  contractNo: string;
  contractItemNo: string;
  atp: string;
  atpDetails: string;
  block: string;
  run: string;
  paperMachine: string;
  conditionUnit?: string;
  conditionRate?: string;
  confirmDate?: string;
  commission?: string;
  commissionAmount?: string;
  commissionUnit?: string;
  remark?: string;
  rollDiameter?: string;
  rollCoreDiameter?: string;
  noOfRoll?: string;
  reamRollPerPallet?: string;
  palletSize?: string;
  palletNo?: string;
  noOfPackage?: string;
  packingList?: string;
  reasonForReject?: string;
  unlimited?: string;
  errorDate?: boolean;
  isChange?: boolean;
  orderNo?: string;
  quantity?: string;
  originQuantity?: string;
  originalRequestDate?: string;
  deliveryTolUnder?: number;
  deliveryTolOver?: number;
  rejectReason?: ScgExportRejectReason;
  refPiNo?: string;
  refPiStock?: string;
  deliveryTolUnlimited?: boolean;
  route?: string;
  weightUnit?: string;
  isAddNew?: boolean;
  isRequestDateChanged?: boolean;
  isDelete?: boolean;
  isK01K09?: boolean;
  rollQuantity?: string;
  inquiryMethod?: string;
  isMaterialOutsource?: boolean;
  itemProductionState?: EOrderingProductionStatus;
  assignQuantity?: number;
  textErrorMessageQuantity?: string;
  poStatus?: string;
  poSubcontract?: string;
  flagR5?: boolean;
}
